import { Component, OnInit } from '@angular/core';
import {IbRequest} from "../ib-request";
import {IbResponse} from "../ib-response";
import {CallBackEndService} from "../call-back-end.service";
import {AuthenticationService} from "../service";
import {timerComponent} from "../cheque-book-request/timerComponent";
import {Router} from "@angular/router";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import {errorHandler} from "@angular/platform-browser/src/browser";
import { SessionTimerComponent } from '../session-timer/session-timer.component';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  [x: string]: any;

  lastloginDate: string;
  NextpasschangeDate: string;

  constructor(
    private webService: CallBackEndService,
    private logoutCall: AuthenticationService,
    private timetStart : timerComponent,
    private http: HttpClient,
	private router:Router,
	   private timer: SessionTimerComponent
  ) {
    this.lastloginDate =sessionStorage.getItem('lastlogindateTime');
    this.NextpasschangeDate =sessionStorage.getItem('NextpasschangeDate');
  }

  ngOnInit() {
	this.timer.stopTimer();
  }




  logout(){
    //this.scAccount=this.scAccounts[0];
   console.log("call service 345345");
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 =sessionStorage.getItem('token');
    request.param2 =sessionStorage.getItem('storedUserName');
    this.timer.stopTimer();
    let userLoggedInForOnePage =sessionStorage.getItem("userLoggedInForOnePage");
    if((userLoggedInForOnePage!=undefined || userLoggedInForOnePage!=null) && userLoggedInForOnePage==='yes'){
      this.webService.getResponse(request, 'logout').subscribe((data: IbResponse) => {
        console.log('logout yuiyu'+data.status);
        this.timer.stopTimer();
        if (data !== null && data.status === 'S200') {
          console.log('logout service');
         sessionStorage.removeItem('currentUser');
         sessionStorage.removeItem('isPasswordExpire');
         sessionStorage.removeItem('token');
         sessionStorage.removeItem('custNo');
         sessionStorage.removeItem('accounts');
     sessionStorage.clear();
         // this.timetStart.stopTimer();
          this.router.navigate(['/login']);
          //this.showLoanAmount ='Hide';
        }
        else{
          this.router.navigate(['/login']);
        }
      });
    }else{
      this.router.navigate(['/login']);
    }
    


  }




}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/error/error.component.ts